import { Outlet } from 'react-router';

import { styled } from '@mui/material';

import { useNotificationsListener } from '@app-velocity/libs/notifications';

import { TopBar } from '../../components/TopBar';
import { AppModalsProtected } from '../../AppModalsProtected';

const StyledSection = styled('section')({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
});

const StyledMain = styled('main')({
  flex: 1,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
});

const StyledLayout = styled('div')({
  height: '100vh',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

export const AuthLayout = () => {
  useNotificationsListener();

  return (
    <StyledLayout>
      <AppModalsProtected />
      <TopBar />
      <StyledSection>
        <StyledMain>
          <Outlet />
        </StyledMain>
      </StyledSection>
    </StyledLayout>
  );
};
